function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m21.113 20c-1.188 0-2.24-.72-2.681-1.835l-1.238-2.793c-.055-.136-.153-.205-.264-.205h-9.86c-.11 0-.209.069-.251.177l-1.262 2.85c-.43 1.086-1.482 1.806-2.67 1.806-.869 0-1.683-.389-2.233-1.068-.559-.689-.773-1.584-.589-2.455l1.993-9.426c.374-1.768 1.944-3.051 3.733-3.051h12.419c1.789 0 3.358 1.283 3.733 3.051l1.993 9.426c.184.871-.03 1.766-.589 2.455-.551.679-1.365 1.068-2.234 1.068zm-14.043-6.333h9.86c.73 0 1.377.442 1.647 1.126l1.238 2.793c.225.566.729.915 1.298.915.415 0 .804-.187 1.068-.513.272-.336.377-.774.287-1.2l-1.993-9.426c-.228-1.079-1.181-1.862-2.266-1.862h-12.418c-1.084 0-2.037.783-2.265 1.861l-1.993 9.426c-.09.426.014.864.287 1.2.263.326.653.513 1.067.513.568 0 1.073-.348 1.286-.886l1.262-2.85c.258-.656.904-1.097 1.635-1.097z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m7.5 12c-.414 0-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5c0 .414-.336.75-.75.75z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m9.25 10.25h-3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m16.5 12c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5zm0-3.5c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1z"
}));

var SvgGame = function SvgGame(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "_x31__x2C_5",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/game.c2f9aa3e.svg";
export { ForwardRef as ReactComponent };